export var DataMessageVariant;
(function (DataMessageVariant) {
    DataMessageVariant[DataMessageVariant["InterimRecognizingSTT"] = 0] = "InterimRecognizingSTT";
    DataMessageVariant[DataMessageVariant["RecognizedSTT"] = 1] = "RecognizedSTT";
})(DataMessageVariant || (DataMessageVariant = {}));
